import React from 'react';

import { HeadingProps } from './Commons';

import './Heading.scss';

const Heading = React.forwardRef(
  (
    props: HeadingProps & { level: '1' | '2' | '3' | '4' | '5' | '6' },
    ref: any
  ) => {
    const { className, level, ...otherProps } = props;

    const newProps = {
      className: `heading lvl-${level} ${className || ''}`,
      ...otherProps,
    };

    return level === '1' ? (
      // eslint-disable-next-line
      <h1 {...newProps} ref={ref} />
    ) : level === '2' ? (
      // eslint-disable-next-line
      <h2 {...newProps} ref={ref} />
    ) : level === '3' ? (
      // eslint-disable-next-line
      <h3 {...newProps} ref={ref} />
    ) : level === '4' ? (
      // eslint-disable-next-line
      <h4 {...newProps} ref={ref} />
    ) : level === '5' ? (
      // eslint-disable-next-line
      <h5 {...newProps} ref={ref} />
    ) : level === '6' ? (
      // eslint-disable-next-line
      <h6 {...newProps} ref={ref} />
    ) : null;
  }
);

export const H = {
  H1: React.forwardRef((props: HeadingProps, ref: any) => (
    <Heading ref={ref} {...props} level='1' />
  )),
  H2: React.forwardRef((props: HeadingProps, ref: any) => (
    <Heading ref={ref} {...props} level='2' />
  )),
  H3: React.forwardRef((props: HeadingProps, ref: any) => (
    <Heading ref={ref} {...props} level='3' />
  )),
  H4: React.forwardRef((props: HeadingProps, ref: any) => (
    <Heading ref={ref} {...props} level='4' />
  )),
  H5: React.forwardRef((props: HeadingProps, ref: any) => (
    <Heading ref={ref} {...props} level='5' />
  )),
  H6: React.forwardRef((props: HeadingProps, ref: any) => (
    <Heading ref={ref} {...props} level='6' />
  )),
};
